import type { PlaylistItem } from '@jwp/ott-common/types/playlist';
import type { CSSProperties, TransitionEventHandler } from 'react';
import React, { useEffect, useRef } from 'react';
import Hls from 'hls.js';

import Image from '../Image/Image';
import styles from './HeroShelf.module.scss';

const HeroShelfBackground = ({
  item,
  style,
  hidden,
  onTransitionEnd,
  showVideo,
}: {
  item: PlaylistItem | null;
  style: CSSProperties;
  hidden?: boolean;
  onTransitionEnd?: TransitionEventHandler;
  showVideo?: boolean;
}) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  const trailerId = (item as any)?.trailerId as string | undefined;
  const trailerUrl = trailerId
    ? `https://cdn.jwplayer.com/manifests/${trailerId}.m3u8`
    : undefined;
  const shouldShowVideo = showVideo === true && !!trailerUrl;

  useEffect(() => {
    console.log("useEffect ejecutado", { shouldShowVideo, trailerUrl, videoRef: videoRef.current });

    if (!shouldShowVideo || !trailerUrl || !videoRef.current) return;
    console.log("Intentando cargar HLS...");
    console.log("Hls.isSupported():", Hls.isSupported());
    if (Hls.isSupported()) {
      const hls = new Hls();
      hls.loadSource(trailerUrl);
      hls.attachMedia(videoRef.current);
      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        videoRef.current?.play().catch(() => {});
      });
      return () => hls.destroy();
    } else if (videoRef.current.canPlayType('application/vnd.apple.mpegurl')) {
      videoRef.current.src = trailerUrl;
      videoRef.current.play().catch(() => {});
    }
  }, [shouldShowVideo, trailerUrl]);

  if (!item) return null;

  const image = item?.backgroundImage;

  return (
    <div
      style={{ ...style, visibility: hidden ? 'hidden' : undefined }}
      aria-hidden={hidden ? 'true' : undefined}
      key={item.mediaid}
      onTransitionEnd={onTransitionEnd}
    >
      {!shouldShowVideo ? (
        <Image className={styles.image} image={image} width={1920} alt={item?.title} />
      ) : (
        <video
          ref={videoRef}
          className={styles.image}
          muted
          playsInline
        />
      )}
    </div>
  );
};

//export default React.memo(HeroShelfBackground);
export default HeroShelfBackground;